/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErrorDef } from './errorDef';


export interface ErrorModule { 
    moduleCode?: string;
    moduleName?: string;
    moduleDescription?: string;
    moduleDefaultErrorMessage?: string;
    errors?: Array<ErrorDef>;
}

